import React, { useState, useEffect, useContext } from "react";
import { FiPlus, FiRefreshCcw } from "react-icons/fi";
import PageTitle from "components/Typography/PageTitle";
import MainDrawer from "components/drawer/MainDrawer";
import TemplateDrawer from "components/drawer/TemplateDrawer";
import MessageDrawer from "components/drawer/MessageDrawer";
import ExportData from "components/common/ExportData";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import TemplateTable from "components/template/TemplateTable";
import MessageTable from "components/template/MessageTable";
import sidebar from "routes/sidebar";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";

import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import WhatsAppServices from "../services/WhatsAppServices";
import { SidebarContext } from "context/SidebarContext";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHeader,
  TableRow,
  Card,
  CardBody,
  Input,
  Button,
} from "@windmill/react-ui";
import { Tabs, Tab } from "@mui/material";
import EmailDrawer from "components/drawer/EmailDrawer";
import EmailTable from "components/template/EmailTable";

const Email = () => {
  const { toggleDrawer, setIsUpdate, isUpdate } = useContext(SidebarContext);
  const [safeData, setSafeData] = useState([]);
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const [tab, setTab] = useState(0); // 0 = Template, 1 = Message
  const [status, setStatus] = useState("");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { dataTable, handleSubmitWhatsapp, WhatsappRef } = useFilter(
    safeData,
    10
  );
  // console.log("messagetable---", dataTable);

  useEffect(() => {
    if (data?.data && Array.isArray(data.data)) {
      setSafeData(data.data);
    }
  }, [data]);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);
      setSafeData([]); // optional: clear old data while loading

      try {
        let freshData =
          tab === 0
            ? await WhatsAppServices.getAllTemplates()
            : await WhatsAppServices.getAllMessages();

        if (freshData?.data && Array.isArray(freshData.data)) {
          setSafeData(freshData.data);
        } else if (Array.isArray(freshData)) {
          setSafeData(freshData);
        } else {
          setSafeData([]);
        }

        setData(freshData); // optional, if you use `data` elsewhere
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err);
        setSafeData([]);
      } finally {
        setLoading(false);
        setIsUpdate(false); // reset refresh trigger
      }
    };

    loadData();
  }, [tab, isUpdate]);

  // Permissions
  const isAdmin = adminInfo?.id === 1;
  const hideView =
    isAdmin ||
    adminInfo?.permission?.some((w) => w.id_tab === "whatsapp" && w.view === 1);
  const hideDelete =
    isAdmin ||
    adminInfo?.permission?.some(
      (w) => w.id_tab === "whatsapp" && w.delete === 1
    );
  const hideExport =
    isAdmin ||
    adminInfo?.permission?.some(
      (w) => w.id_tab === "whatsapp" && w.export === 1
    );
  const hideAdd =
    isAdmin ||
    adminInfo?.permission?.some((w) => w.id_tab === "whatsapp" && w.add === 1);

  const { title, serviceId, handleModalOpen, handleUpdate, isSubmitting } =
    useToggleDrawer();

  const refreshData = () => setIsUpdate(true);

  const handleDelete = async (id) => {
    if (tab === 0) {
      await WhatsAppServices.deleteTemplate(id);
    } else {
      await WhatsAppServices.deleteMessage(id);
    }
    refreshData();
  };

  // CSV export
const exportCsvData = (tab, safeData) => {
  let csvDataArray = [];

  if (tab === 0) {
    // Template tab
    csvDataArray = [
      ["Name", "Category", "Language", "Status"],
      ...(Array.isArray(safeData)
        ? safeData.map((t) => [t.name, t.category, t.language, t.status])
        : []),
    ];
  } else if (tab === 1) {
    // Message tab
    csvDataArray = [
      ["Template Name", "Category", "Content", "Time", "Status"],
      ...(Array.isArray(safeData)
        ? safeData.map((m) => [
            m.template_name ||
              m.template_content?.name ||
              `Template #${m.whatsapp_template_id}`,
            m.category,
            m.template_content?.components?.find((c) => c.type === "BODY")
              ?.text || "",
            m.created_at,
            m.status,
          ])
        : []),
    ];
  }

  const [headers, ...rows] = csvDataArray;
  return rows.map((row) =>
    headers.reduce((acc, header, i) => {
      acc[header] = row[i];
      return acc;
    }, {})
  );
};

// Generate export data for the current tab
const csvData = exportCsvData(tab, safeData);


  // Map message data before passing to MessageTable
  const mappedMessages =
    tab === 1
      ? dataTable.map((msg) => {
          // Safely extract text from BODY component
          const bodyComponent = msg.template_content?.components?.find(
            (c) => c.type === "BODY"
          );
          const messageText = bodyComponent?.text;

          return {
            id: msg.id,
            name:
              msg.template_content?.name ||
              `Template #${msg.whatsapp_template_id}`,
            category: msg.category,
            content: messageText,
            created_at: msg.created_at,
            status: msg.status,
          };
        })
      : [];

  // console.log("message data for rendering---", mappedMessages);

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />
          <PageTitle sidebar={sidebar().sidebar} />

          <MainDrawer>
            
          <EmailDrawer />
          </MainDrawer>

          {/* Search + Action Bar */}
          <Card className="shadow-xs bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <form
                className="flex gap-6 items-center"
                onSubmit={handleSubmitWhatsapp}
              >
                <div className="flex-1">
                  <Input
                    ref={WhatsappRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    placeholder="Quick Search"
                    onChange={handleSubmitWhatsapp}
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10 flex items-center gap-2"
                  >
                    <FiPlus />
                    {"Send Email"}
                  </Button>
                )}

                {hideExport && (
                  <ExportData
                    title={"Email"}
                    exportData={csvData}
                    fileNames={`Email List`}
                  />
                )}

                <FiRefreshCcw
                  onClick={refreshData}
                  className="cursor-pointer text-lg"
                />
              </form>
            </CardBody>
          </Card>

          {/* Tabs */}
  

          <div className="data-table-container">
          {/* Table Section */}
            <DataWrapper loading={loading} error={error} status={status}>
              {dataTable?.length > 0 ? (
                <TableContainer>
                  <Table>
                    <TableHeader>
                      <tr>
                        <TableCell className="text-center text-xs">
                          SI.No
                        </TableCell>
                        
                        <TableCell className="text-center text-xs">
                          Category
                        </TableCell>
                    
                          <TableCell className="text-center text-xs">
                            Language
                          </TableCell>
                     
                     
                          <TableCell className="text-center text-xs">
                            Content
                          </TableCell>
                       
                          <TableCell className="text-center text-xs">
                            Time
                          </TableCell>
                       
                        <TableCell className="text-center text-xs">
                          Status
                        </TableCell>
                        <TableCell className="text-center text-xs">
                          Actions
                        </TableCell>
                      </tr>
                    </TableHeader>

                    <TableBody>
              
                        <EmailTable
                          messagedata={mappedMessages}
                          handleUpdate={handleUpdate}
                          handleModalOpen={handleModalOpen}
                          hideDelete={hideDelete}
                        />
                  
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <div
                  className="mb-8 flex items-center justify-center"
                  style={{ minHeight: "65vh" }}
                >
                  <NotFound
                    title={"No Email Found"}
                  />
                </div>
              )}
            </DataWrapper>
          </div>
        </>
      )}
    </>
  );
};

export default Email;
